import React from "react"
import { useTranslation } from "react-i18next"
import { EmployeeLink } from "~Components/employeeLink"
import { useEmployee } from "~Shared/queries/employee.queries"
import { formatDate } from "~Shared/utils/date.utils"
import { DeliveryNote } from "../types/deliveryNote.interfaces"

export const DeliveryNoteTabContent = ({ deliveryNote }: { deliveryNote: DeliveryNote }) => {
    const { t } = useTranslation()

    const { data: employee } = useEmployee(deliveryNote.createdBy._id)

    return (
        <div className="p-6">
            <ul className="description-list pb-10 overflow-hidden">
                {deliveryNote.dateOfIssue ? (
                    <li>
                        <span className="title">{t("label:delivery_date")}</span>
                        <span className="text">{formatDate(deliveryNote.dateOfIssue)}</span>
                    </li>
                ) : null}

                <li>
                    <span className="title">{t("label:delivery_location")}</span>
                    <span className="text">{deliveryNote.deliveryLocation?.addressLine1}</span>
                </li>

                <li>
                    <span className="title">{t("label:created_on")}</span>
                    <span className="text">{formatDate(deliveryNote.createdAt)}</span>
                </li>

                {employee ? (
                    <li>
                        <span className="title">{t("label:created_by")}</span>
                        <EmployeeLink employee={employee} />
                    </li>
                ) : null}
            </ul>
        </div>
    )
}
